import React, { useContext } from "react";
import { ProgressBar } from "react-bootstrap";
import { TestsContext } from "../../contexts";

/** Testing progress.
 *  Monitors the tests context and shows progress.
 */
export const Status = () => {
  const { tests } = useContext(TestsContext);
  const { testCount } = tests;

  /** Calculate the percent of the tests done.
   */
  const percent = () => {
    let p = Math.trunc((testCount / 40) * 100);
    return p > 100 ? 100 : p;
  };

  /** Render.
   */
  return (
    <>
      <ProgressBar striped variant='success' now={percent()} label={`${percent()}%`} />
    </>
  );
};
